function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "white",
  d: "M7.96293 7.66541C5.45385 7.66541 3.33679 8.0754 3.33679 9.65776C3.33679 11.2408 5.46752 11.6364 7.96293 11.6364C10.472 11.6364 12.5891 11.2264 12.5891 9.64401C12.5891 8.06099 10.4583 7.66541 7.96293 7.66541Z",
  fill: "#C4C4C4"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "opacity",
  opacity: 0.4,
  d: "M7.96291 6.15784C9.6619 6.15784 11.0242 4.78768 11.0242 3.07892C11.0242 1.3695 9.6619 0 7.96291 0C6.26393 0 4.90161 1.3695 4.90161 3.07892C4.90161 4.78768 6.26393 6.15784 7.96291 6.15784Z",
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "opacity",
  opacity: 0.4,
  d: "M14.6094 3.79575C15.049 2.06668 13.7603 0.513794 12.1192 0.513794C11.9408 0.513794 11.7702 0.533442 11.6035 0.566845C11.5813 0.572084 11.5566 0.583219 11.5436 0.602867C11.5286 0.627755 11.5397 0.661158 11.5559 0.682771C12.0489 1.37833 12.3322 2.22518 12.3322 3.13425C12.3322 4.00533 12.0723 4.81747 11.6165 5.49141C11.5696 5.56084 11.6113 5.6545 11.694 5.6689C11.8086 5.68921 11.9258 5.69969 12.0456 5.70296C13.2406 5.7344 14.3131 4.9609 14.6094 3.79575Z",
  fill: "#C4C4C4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "white",
  d: "M15.8612 7.86687C15.6424 7.39792 15.1143 7.07634 14.3114 6.9185C13.9324 6.8255 12.9067 6.69451 11.9527 6.71219C11.9384 6.71416 11.9306 6.72398 11.9293 6.73053C11.9273 6.7397 11.9312 6.75542 11.9501 6.76524C12.391 6.98465 14.0952 7.93891 13.8809 9.95157C13.8718 10.0387 13.9415 10.114 14.0281 10.1009C14.4475 10.0406 15.5265 9.80748 15.8612 9.08114C16.0462 8.69734 16.0462 8.25132 15.8612 7.86687Z",
  fill: "#C4C4C4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "opacity",
  opacity: 0.4,
  d: "M4.39627 0.567089C4.23022 0.533032 4.05895 0.514038 3.88052 0.514038C2.23949 0.514038 0.950765 2.06692 1.39098 3.79599C1.68662 4.96115 2.75915 5.73464 3.95411 5.70321C4.07393 5.69993 4.1918 5.6888 4.30576 5.66915C4.38846 5.65474 4.43014 5.56108 4.38325 5.49166C3.92741 4.81706 3.66758 4.00558 3.66758 3.13449C3.66758 2.22477 3.9515 1.37792 4.44446 0.683015C4.46009 0.661402 4.47181 0.627999 4.45619 0.603111C4.44316 0.582808 4.41907 0.572329 4.39627 0.567089Z",
  fill: "#C4C4C4"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "white",
  d: "M1.6884 6.91833C0.885472 7.07617 0.357998 7.39775 0.139194 7.86669C-0.0463981 8.25115 -0.0463981 8.69717 0.139194 9.08163C0.473912 9.80731 1.55295 10.0411 1.97233 10.1007C2.05894 10.1138 2.12797 10.0392 2.11885 9.9514C1.9046 7.93939 3.6088 6.98513 4.05031 6.76572C4.06855 6.75524 4.07245 6.74018 4.0705 6.73036C4.0692 6.72381 4.06204 6.71398 4.04771 6.71267C3.09305 6.69433 2.06805 6.82532 1.6884 6.91833Z",
  fill: "#C4C4C4"
});

function SvgMerchants({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchants);
export default __webpack_public_path__ + "static/media/merchants.db888957.svg";
export { ForwardRef as ReactComponent };